import React from 'react';
import { Box } from '@mui/material';

type SvgImageName =
  | 'logomark_purple'
  | 'spy_view'
  | 'server'
  | 'login'
  | 'router'
  | 'chat'
  | 'search'
  | 'cloud_privacy'
  | 'alert'
  | 'team_img_1'
  | 'team_img_2'
  | 'team_img_3'
  | 'team_img_4'
  | 'logo_menu'
  | 'contact_email_img'
  | 'contact_location_img'
  | 'contact_phone_img';

interface CustomSvgIconProps {
  name: SvgImageName;
  size?: number;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export default function CustomSvgIcon({
  name,
  size = 64,
  className,
  onClick,
  style,
}: CustomSvgIconProps) {
  const getSvgPath = (): string => {
    const svgMap: Record<SvgImageName, string> = {
      logomark_purple: '/logomark_purple.svg',
      spy_view: '/spy view.svg',
      server: '/server.svg',
      login: '/login.svg',
      router: '/router.svg',
      chat: '/chat.svg',
      search: '/search.svg',
      cloud_privacy: '/cloud privacy.svg',
      alert: '/alert.svg',
      team_img_1: '/team_img_1.svg',
      team_img_2: '/team_img_2.svg',
      team_img_3: '/team_img_3.svg',
      team_img_4: '/team_img_4.svg',
      logo_menu: '/logo_menu.svg',
      contact_email_img: '/contact_email_img.svg',
      contact_location_img: '/contact_location_img.svg',
      contact_phone_img: '/contact_phone_img.svg',
    };

    return svgMap[name] || svgMap.alert;
  };

  return (
    <Box
      component='img'
      src={getSvgPath()}
      alt={`${name} icon`}
      className={className}
      onClick={onClick}
      style={style}
      sx={{
        width: size,
        height: size,
        display: 'block',
        cursor: onClick ? 'pointer' : 'default',
        objectFit: 'contain',
      }}
    />
  );
}
